<script>


export default {
  name: 'Icon',

  props: {
    icon: {
      type: String,
      required: true,
    },
    size:{type: Number},
    color:{type: String}
  },

}
</script>

<template>
  <span :class="`las ${icon}`" :style="{color,fontSize: `${size}px`}"></span>
</template>
